import Loading from "vue-loading-overlay";
import * as config from "@/config.json";
import axios from "axios";

export default {
  name: "MicroService",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      itemsMicroService: [],
      id: null,
      description: null,
      currentPage: 1,
      perPage: 12,
      token: null,
      fields: [{
          key: "id",
          label: "Id"
        },
        {
          key: "description",
          label: "Descrição"
        },
      ],
      paramsMicroService: {}
    };
  },

  methods: {
    redirect(ref) {
      this.$router.push(ref);
    },

    async builtParamsMicroService() {
      this.paramsMicroService = {
        id: this.id,
        description: this.description
      }
    },

    async editMicroService(microService) {
      this.id = microService.Id;
      this.description = microService.type;

      await this.builtParamsMicroService();

      this.$router.push({
        name: "MicroServiceManager",
        params: this.paramsMicroService
      });
    },

    async getMicroService() {
      this.isLoading = true;
      const url = `${config.default.urlBasePandora}/admin/micro-service-type`;

      try {
        const response = await axios({
          url,
          method: "get",
          params: {
            "description": this.description
          },
          headers: {
            authorization: `Bearer ${this.token}`
          },
        });
        
        if (response.status == 200) {
          this.isLoading = false;
          this.itemsMicroService = response.data.microServiceTypes;
        }
      } catch (error) {
        this.isLoading = false;

        if (error.response.status == 403) {
          this.isLoading = false;
          await this.$alert(
            "Sua sessão expirou. Faça o login novamente!",
            "Aviso",
            "warning"
          );
          this.$router.push("login");
        }

        if (error.response.status == 404) {
          this.getNotification(
            "Aviso",
            "Nenhum registro encontrado!",
            "warning"
          );
        }
      }
    }
  },

  async beforeMount() {
    this.isLoading = true;
    this.token = localStorage.getItem("token");
    await this.getMicroService();
    this.isLoading = false;
  },

  computed: {
    rows() {
      return this.itemsMicroService.length;
    },
  },
}